let activeRequests = 0;
let listeners = [];

let visible = false;
let warningVisible = false;
let warningType = null; // null | 'slow' | 'network'

let showTimer = null;
let hideTimer = null;
let warningTimer = null;

const SHOW_DELAY = 150;
const MIN_VISIBLE_TIME = 350;
const WARNING_DELAY = 15000;

let shownAt = 0;

const getState = () => ({
  activeRequests,
  visible,
  warningVisible,
  warningType,
});

const notify = () => {
  const state = getState();

  listeners.forEach((listener) => listener(state));
};

export const subscribeLoader = (listener) => {
  listeners.push(listener);

  listener(getState());

  return () => {
    listeners = listeners.filter((item) => item !== listener);
  };
};

export const isLoaderVisible = () => visible;

const hideWarning = () => {
  clearTimeout(warningTimer);
  warningTimer = null;

  warningVisible = false;
  warningType = null;
};

const showWarning = (type) => {
  clearTimeout(warningTimer);
  warningTimer = null;

  clearTimeout(showTimer);
  showTimer = null;

  clearTimeout(hideTimer);
  hideTimer = null;

  warningVisible = true;
  warningType = type;
  visible = true;

  notify();
};

export const startLoading = () => {
  const wasIdle = activeRequests === 0;

  activeRequests++;

  clearTimeout(hideTimer);
  hideTimer = null;

  /*
   * Началась новая группа запросов.
   */
  if (wasIdle) {
    /*
     * Старое network-предупреждение можно убрать,
     * потому что начался новый запрос.
     */
    hideWarning();

    warningTimer = setTimeout(() => {
      if (activeRequests > 0 && !warningVisible) {
        showWarning('slow');
      }
    }, WARNING_DELAY);
  }

  notify();

  if (visible || showTimer) {
    return;
  }

  showTimer = setTimeout(() => {
    showTimer = null;

    if (activeRequests > 0) {
      visible = true;
      shownAt = Date.now();

      notify();
    }
  }, SHOW_DELAY);
};

/*
 * Успешный HTTP-ответ.
 *
 * Если до этого был network warning,
 * значит backend снова доступен.
 */
export const requestSucceeded = () => {
  activeRequests = Math.max(0, activeRequests - 1);

  /*
   * Успешный запрос означает,
   * что backend снова отвечает.
   */
  if (warningType === 'network') {
    hideWarning();
  }

  notify();

  finishIfIdle();
};

/*
 * Обычная ошибка HTTP:
 * 400, 401, 403, 404, 500 и т.д.
 */
export const stopLoading = () => {
  activeRequests = Math.max(0, activeRequests - 1);

  notify();

  finishIfIdle();
};

/*
 * Сетевая ошибка:
 * backend выключен, ECONNREFUSED,
 * ERR_NETWORK, timeout и т.п.
 */
export const networkErrorLoading = () => {
  activeRequests = Math.max(0, activeRequests - 1);

  showWarning('network');
};

export const dismissWarning = () => {
  warningVisible = false;
  warningType = null;

  notify();
};

const finishIfIdle = () => {
  if (activeRequests > 0) {
    return;
  }

  clearTimeout(warningTimer);
  warningTimer = null;

  clearTimeout(showTimer);
  showTimer = null;

  /*
   * Network warning не закрываем автоматически.
   * Он должен оставаться до успешного запроса.
   */
  if (warningType === 'network') {
    visible = true;
    notify();

    return;
  }

  /*
   * Slow warning больше не нужен:
   * все запросы завершились.
   */
  if (warningType === 'slow') {
    hideWarning();
  }

  if (!visible) {
    notify();
    return;
  }

  const elapsed = Date.now() - shownAt;

  const remaining = Math.max(
    0,
    MIN_VISIBLE_TIME - elapsed
  );

  clearTimeout(hideTimer);

  hideTimer = setTimeout(() => {
    if (activeRequests === 0 && !warningVisible) {
      visible = false;

      notify();
    }
  }, remaining);
};